//
import { ModuleLayout } from '@/components/reusable_components/next'
import PchProviderAccountBankListView from '@/views/Purchase/PchProviderAccountBank/PchProviderAccountBankList'

//
export default {
  path: 'provider_account_bank',
  component: ModuleLayout,
  children: [
    {
      path: '',
      name: 'provider-account-bank-list',
      component: PchProviderAccountBankListView,
    },
  ],
  meta: {
    title: 'Cuentas de banco de proveedores',
  },
}
